
import { Button, createStyles, makeStyles } from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => createStyles({
    root: {
        fontWeight: 400,
        fontSize: "0.95rem"
    }
}));


interface IOrderBaseButtonProps {
    onClick: () => void;
    label: string;
    buttonProps?: any;
    disabled?: boolean;

}
export function OrderBaseButton({
    onClick,
    label,
    buttonProps,
    disabled
}: IOrderBaseButtonProps) {
    const { t } = useTranslation();
    const { root } = useStyles()

    return <Button
        variant="outlined"
        onClick={onClick}
        className={root}
        disabled={disabled}
        {...buttonProps}
    >
        {t(label)}
    </Button>
}